const addSuccessStoriesConstantsAr = {
  listOfSuccessStoriesTitle: ' قصص النجاح',
  successStoriesBreadcrumbs: 'قصص النجاح',
  addSuccessStoriesPageTitle: 'قصة نجاح جديدة',
  editSuccessStoriesPageTitle: 'تعديل قصة نجاح',
  successStoriesSaveDraftBtn: 'حفظ المسودة',
  successStoriesSaveBtn: 'حفظ',
  successStoriesCreateBtn: 'إضافة قصة نجاح',
  successStoriesName: 'اسم الكاتب',
  successStoriesStatus: 'الحالة',
  successStoriesDraft: 'مسودة',
  successStoriesPublished: 'منشور',
  successStoriesDeleteDialogTitle: 'حذف قصة نجاح',
  successStoriesDeleteDialogMessage: 'هل أنت متأكد من أنك تريد حذف قصة النجاح هذه؟',
  successStoriesEdit: 'تعديل',
  cmsSuccessStoriesTableState: 'الحالة',
  cmsSuccessStoriesTablePublishDate: 'تاريخ النشر',
};

export default addSuccessStoriesConstantsAr;
